export const amplifyConfig = {
    aws_project_region: process.env.NEXT_PUBLIC_AWS_PROJECT_REGION,
    aws_cognito_identity_pool_id:
        process.env.NEXT_PUBLIC_AWS_COGNITO_IDENTITY_POOL_ID,
    aws_cognito_region: process.env.NEXT_PUBLIC_AWS_COGNITO_REGION,
    aws_user_pools_id: process.env.NEXT_PUBLIC_AWS_USER_POOLS_ID,
    aws_user_pools_web_client_id:
        process.env.NEXT_PUBLIC_AWS_USER_POOLS_WEB_CLIENT_ID
}

export const auth0Config = {
    client_id: process.env.NEXT_PUBLIC_AUTH0_CLIENT_ID,
    domain: process.env.NEXT_PUBLIC_AUTH0_DOMAIN
}

export const apiConfig = {
    endpoint: process.env.NEXT_PUBLIC_BACKEND_API_ENDPOINT
}

export const apiBaseUrl = process.env.NEXT_PUBLIC_BACKEND_API_ENDPOINT + '/'

export const paymentConfig = {
    stripe_key: process.env.NEXT_PUBLIC_APP_STRIPE_KEY,
    minPaymentPrice: parseInt(process.env.NEXT_PUBLIC_MIN_PAYMENT_PRICE)
}

export const firebaseConfig = {
    apiKey: process.env.NEXT_PUBLIC_FIREBASE_API_KEY,
    appId: process.env.NEXT_PUBLIC_FIREBASE_APP_ID,
    authDomain: process.env.NEXT_PUBLIC_FIREBASE_AUTH_DOMAIN,
    databaseURL: process.env.NEXT_PUBLIC_FIREBASE_DATABASE_URL,
    messagingSenderId: process.env.NEXT_PUBLIC_FIREBASE_MESSAGING_SENDER_ID,
    projectId: process.env.NEXT_PUBLIC_FIREBASE_PROJECT_ID,
    storageBucket: process.env.NEXT_PUBLIC_FIREBASE_STORAGE_BUCKET
}

export const gtmConfig = {
    containerId: process.env.NEXT_PUBLIC_GTM_CONTAINER_ID
}

export const siteConfig = {
    recaptchaKey: process.env.NEXT_PUBLIC_RECAPTCHA_KEY,
    theme: process.env.NEXT_PUBLIC_THEME,
    lang: process.env.NEXT_PUBLIC_LANG
}

export const calendlyConfig = {
    url: process.env.NEXT_PUBLIC_CALENDLY_URL
}

export const socialMediaConfig = {
    onboardingUrl: process.env.NEXT_PUBLIC_SOCIAL_MEDIA_ONBOARDING_URL
}

export const reportingConfig = {
    windowMonths: parseInt(
        process.env.NEXT_PUBLIC_REPORTING_WINDOW_MONTHS ?? '13'
    )
}
